import axios, {AxiosError, AxiosResponse} from 'axios';
import { toast } from 'react-toastify';
import { history } from '../..';
import { Activity, ActivityFormValues } from '../models/activity'
import { Foto, Profile } from '../models/profile';
import { Degree, SGPersona, SGPersonaFormValues} from '../models/SGPersona';
import { SGTDepartamento } from '../models/SGTDepartamentos';
import { SGTEntidad } from '../models/SGTEntidades';
import { SGTMunicipio } from '../models/SGTMunicipios';
import { SGTComunidad } from '../models/SGTComunidades';
import { CCTipoDeCuenta, CCTiposDeCuentasFormValues } from '../models/CCTiposDeCuentas';
import { CCTipoDeDocumento, CCTiposDeDocumentosFormValues } from '../models/CCTiposDeDocumentos';
import { CCTipoDeTransaccion, CCTiposDeTransaccionFormValues } from '../models/CCTiposDeTransaccion';
import { CCTTiposTransXTipoCta, CCTTiposTransXTipoCtaFormValues } from '../models/CCTTiposTransXTipoCta';
import { CCTCuenta } from '../models/CCTCuenta';
import { CCTMovimiento } from '../models/CCTMoviemientos';
import { InscriptionFormValues } from '../models/Inscriptions';
import { DeleteInscriptionFormValues } from '../models/DeleteInscriptions';
import { CCTOperacion, CCTOperacionesFormValues } from '../models/CCTOperacion';
import { CCTMovimientoReportes } from '../models/CCTMovimientoReporte';
import { CCTMovimientoConsultaFormValues } from '../models/CCTMovimientoConsulta';
import { SaldosReportes } from '../models/SaldosReporte';
import { DPI } from '../models/dpi';
import { store } from '../stores/store';
import { Information } from '../models/Carga';
import {  CuotasMod, CuotasModFormValues } from '../models/CuotasMod';
import { getTranx, getTranxTipoCta } from '../models/getTranxTipoCta';
import { CATCursosL, createCATCursos, createCATCursosFormValues, getCATCursos, lstCourses, Pagination } from '../models/CATCursos';
import {CATEdiciones, CATEdicionesL, getEdiciones } from '../models/CATEdiciones';
import { ExoneracionesDetail, ExoneracionesList, ExoneracionesMod, ExoneracionesModFormValues } from '../models/ExoneracionesMod';
import { Notificacion, User, UserFormValues } from '../models/user';
import { RecibosFormValues } from '../models/RecibosMod';
import {CCTPlanCuotaDetails} from '../models/CCTPlanCuota';
import { BuscarEntidad, createCATConvenios } from '../models/CATConveniosCreate';
import { createCATModulos } from '../models/CATModulos';
import { getCATCursoDetail } from '../models/DetailCATCurso';
import { PassModFormValues, ResetPassModFormValues } from '../models/PassWord';
import { getCATNotas } from '../models/CATNotas';
import { RecibosAgenciaFormValues } from '../models/PagoAgenciaMod';
import { createPermisostoRol, listPermisosByRoleFormValues, listPermisosFormValues, listRolesFormValues } from '../models/Roles';
import { ReportDTO, ReporteInscripcionFormValues } from '../models/ReporteInscritos';
import { ReporteBanruralFormValues } from '../models/ReporteBanrural';
import { ListDocentes } from '../models/ListDocentes';
import { Delegacion } from '../models/ListDelegaciones';
import { CambiarCorreoyContraseña, CambiarCorreoyContraseñaFormValues, RecuperarUsuarioFormValues, RecuperarUsuarioRespuesta } from '../models/RecuperarUsuario';
import { CoursesList, UserList, UserListBusqueda, UserListBusquedaFormValues, cuentasCursosList } from '../models/UsersList';
import { MovimientoFormValues } from '../models/CCTMovimientoCreate';
import { MontoCuota } from '../models/montoCuota';
import { Phone, Windows } from 'react-bootstrap-icons';

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.interceptors.request.use(config => {
    //const token = store.commonStore.token!;
    const token = localStorage.getItem('jwt');    
    if (token) config.headers['Authorization'] = `Bearer ${token}`
    return config;
})

axios.interceptors.response.use(response => {
    return response;
}, async error => {
    const {data, status } = error.response!;
    const originalRequest = error.config;
    switch (status) {
        case 400:
            if (typeof data === 'string') {
                toast.error(data);
            }
            // if (config.method === 'get' && data.errors.hasOwnProperty('id')) {
            // }
            if (data.errors) {
                const modalStateErrors = [];
                for (const key in data.errors) {
                    if (data.errors[key]) {
                        modalStateErrors.push(data.errors[key])
                    }
                }
                throw modalStateErrors.flat();
            }
            break;
        case 401:  
            try {
                const refreshTokenOld = localStorage.getItem('refreshToken');                
                if (!refreshTokenOld) {                
                    toast.error('no autorizado');
                    localStorage.clear();
                   // window.location.href = '/';
                }                    
                const response = await axios.post('/account/refresh', {
                    refreshToken : refreshTokenOld
                });
                
                /* .then(function (response) {
                    const data = response.data;
                    
                    if (data) {                    
                        localStorage.setItem('jwt', data.jwt);
                        localStorage.setItem('refreshToken', data.refreshToken);

                        axios.defaults.headers.Authorization = `Bearer ${data.jwt}`;

                        return axios(originalRequest);
                    }
                });                 */

                const { jwt, refreshToken } = response.data;
                localStorage.setItem('jwt', jwt);
                localStorage.setItem('refreshToken', refreshToken);
                axios.defaults.headers.common["Authorization"] = `Bearer ${jwt}`;                
                return axios(originalRequest);                
            } catch (refreshError) {
                localStorage.removeItem('jwt');
                localStorage.removeItem('refreshToken');
                window.location.href = '/';
                return Promise.reject(refreshError);
            }
            break;
        case 200:
            toast.success(data);
            break;
        case 404:
            break;
        case 500:
            store.commonStore.setServerError(data);
            //history.push('/server-error');
            localStorage.clear();
            window.location.href = '/';
            break;
    }
    return Promise.reject(error);
});

const responseBody = <T> (response: AxiosResponse<T>) => response.data;

const requests = {
    get:  <T> (url: string) => axios.get<T>(url).then(responseBody),
    post: <T> (url: string, body: {}) => axios.post<T>(url, body).then(responseBody),
    put:  <T> (url: string, body: {}) => axios.put<T>(url, body).then(responseBody),
    del:  <T> (url: string) => axios.delete<T>(url).then(responseBody),

}

const Activities = {
    list: () => requests.get<Activity[]>('/activities'),
    details: (id: string) => requests.get<Activity>(`/activities/${id}`),
    create: (activity: ActivityFormValues) => requests.post<void>('/activities', activity),
    update: (activity: ActivityFormValues) => requests.put<void>(`/activities/${activity.id}`, activity),
    delete: (id: string) => requests.del<void>(`/activities/${id}`),
    attend: (id: string) => requests.post<void>(`/activities/${id}/attend`, {})
}

const SGPersonas = {
    list: () => requests.get<SGPersona[]>('/SGPersonas'),
    details: (UserID: string) => requests.get<SGPersona>(`/SGPersonas/${UserID}`),
    create: (SGPersona: SGPersonaFormValues) => requests.post<void>('/SGPersonas', SGPersona),
    update: (SGPersona: SGPersonaFormValues) => requests.put<void>(`/SGPersonas/${SGPersona.dpi}`, SGPersona),
    delete: (dpi: string) => requests.del<void>(`/SGPersonas/${dpi}`),
    dpi: () => requests.get<DPI[]>('/SGPersonas/getDpiAndNames'),
    persona: (dpi: string) => requests.get<DPI[]>(`/findByDPI/${dpi}`)
}

const SGTDepartamentos = {
    list: () => requests.get<SGTDepartamento[]>('/SGTDepartamentos'),
    details: (iddeparta: string) => requests.get<SGTDepartamento>(`/SGTDepartamentos/${iddeparta}`),
}

const SGTEntidades = {
    list: () => requests.get<SGTEntidad[]>('/SGTEntidades'),
    details: (idEntidad: string) => requests.get<SGTEntidad>(`/SGTEntidades/${idEntidad}`),
}

const SGTMunicipios = {
    list: () => requests.get<SGTMunicipio[]>('/SGTMunicipios'),
    details: (idmuni: string) => requests.get<SGTMunicipio>(`/SGTMunicipios/${idmuni}`),
}

const SGTComunidades = {
    list: () => requests.get<SGTComunidad[]>('/SGTComunidades'),
    details: (idcomunidad: string) => requests.get<SGTComunidad>(`/SGTComunidades/${idcomunidad}`),
}

const CCTiposDeCuentas = {
    list: () => requests.get<CCTipoDeCuenta[]>('/CCTTiposDeCuentas'),
    details: (codigoTipoCuenta: string) => requests.get<CCTipoDeCuenta>(`/CCTTiposDeCuentas/${codigoTipoCuenta}`),
    create: (CCTipoDeCuenta: CCTiposDeCuentasFormValues) => requests.post<void>('/CCTTiposDeCuentas', CCTipoDeCuenta),
    update: (CCTipoDeCuenta: CCTiposDeCuentasFormValues) => requests.put<void>(`/CCTTiposDeCuentas/${CCTipoDeCuenta.codigoTipoCuenta}`, CCTipoDeCuenta),
    delete: (codigoTipoCuenta: string) => requests.del<void>(`/CCTTiposDeCuentas/${codigoTipoCuenta}`),
}

const CCTiposDeDocumentos = {
    list: () => requests.get<CCTipoDeDocumento[]>('/CCTTiposDeDocumentos'),
    details: (codigoTipoDocumento: string) => requests.get<CCTipoDeDocumento>(`/CCTTiposDeDocumentos/${codigoTipoDocumento}`),
    create: (CCTipoDeDocumento: CCTiposDeDocumentosFormValues) => requests.post<void>('/CCTTiposDeDocumentos', CCTipoDeDocumento),
    update: (CCTipoDeDocumento: CCTiposDeDocumentosFormValues) => requests.put<void>(`/CCTTiposDeDocumentos/${CCTipoDeDocumento.codigoTipoDocumento}`, CCTipoDeDocumento),
    delete: (codigoTipoDocumento: string) => requests.del<void>(`/CCTTiposDeDocumentos/${codigoTipoDocumento}`),
}

const CCTiposDeTransacciones = {
    list: () => requests.get<CCTipoDeTransaccion[]>('/CCTTiposDeTransacciones'),
    details: (codigoTipoTransaccion: string) => requests.get<CCTipoDeTransaccion>(`/CCTTiposDeTransacciones/${codigoTipoTransaccion}`),
    create: (CCTipoDeTransaccion: CCTiposDeTransaccionFormValues) => requests.post<void>('/CCTTiposDeTransacciones', CCTipoDeTransaccion),
    update: (CCTipoDeTransaccion: CCTiposDeTransaccionFormValues) => requests.put<void>(`/CCTTiposDeTransacciones/${CCTipoDeTransaccion.codigoTipoTransaccion}`, CCTipoDeTransaccion),
    delete: (codigoTipoTransaccion: string) => requests.del<void>(`/CCTTiposDeTransacciones/${codigoTipoTransaccion}`),
}

const CCTTiposTransXTipoCtas = {
    list: () => requests.get<CCTTiposTransXTipoCta[]>('/CCTTiposTransXTipoCtas'),
    details: (codigoTipoCuenta: string) => requests.get<CCTTiposTransXTipoCta>(`/CCTTiposTransXTipoCtas/${codigoTipoCuenta}/codigo`),
    create: (CCTTiposTransXTipoCta: CCTTiposTransXTipoCtaFormValues) => requests.post<void>('/CCTTiposTransXTipoCtas', CCTTiposTransXTipoCta),
    update: (CCTTiposTransXTipoCta: CCTTiposTransXTipoCtaFormValues) => requests.put<void>(`/CCTTiposTransXTipoCtas/${CCTTiposTransXTipoCta.codigoTipoCuenta}`, CCTTiposTransXTipoCta),
    delete: (codigoTipoCuenta: string) => requests.del<void>(`/CCTTiposTransXTipoCtas/${codigoTipoCuenta}`),
    movimientos: (cuenta: string) => requests.get<getTranxTipoCta[]>(`/CCTTiposTransXTipoCtas/getTranxTipoCta/${cuenta}/id`),
    transmanual: (cuenta: string) => requests.get<getTranxTipoCta[]>(`/CCTTiposTransXTipoCtas/getTranxTipoCta/${cuenta}/codigo`),

}

const CCTCuentas = {
    list: () => requests.get<CCTCuenta[]>('/CCTCuentas'),
    details: (idCliente: string) => requests.get<CCTCuenta[]>(`/CCTCuentas/${idCliente}`),
}

const CCTMovimientos = {
    details: (idCliente: string, cuenta: string) => requests.get<CCTMovimiento[]>(`/CCTMovimientos/${idCliente}/${cuenta}`),
    /*inserta: (fechaproceso: string) => requests.put<string>(`/CCTMovimientos/InsertMovementUPDATEBALANCE/fechaproceso/${fechaproceso}`, CCTMovimientos),*/
    delete: (userId: string, cuenta: string, codigoTipoTransaccion: number, numeroTransaccion: string) => requests.del<any>(`CCTMovimientos/${userId}/${cuenta}/${codigoTipoTransaccion}/${numeroTransaccion}`),
    create: (Movimiento: MovimientoFormValues) => requests.post<string>(`CCTMovimientos/`,Movimiento),
    edit: (idCliente: string, cuenta: string, codigoTipoTransaccion: number, numeroTipoTransaccion: string, Movimiento: MovimientoFormValues) => requests.put<string>(`CCTMovimientos/${idCliente}/${cuenta}/${codigoTipoTransaccion}/${numeroTipoTransaccion}`, Movimiento)
    // Omar 
}

const CCTOperaciones = {
    create : (CCTOperacion: CCTOperacionesFormValues) => requests.post<string>('/CCTMovimientos', CCTOperacion),
    report: (CCTMovimientoConsulta: CCTMovimientoConsultaFormValues) => requests.post<CCTMovimientoReportes[]>('/CCTMovimientos/ReportByDateRange', CCTMovimientoConsulta),
    update: (id: number, estatus: string) => requests.put<string>(`/CCTMovimientos/updateStatus/id/${id}/status/${estatus}`, CCTOperacion)
}

const SaldosReporte = {
    report: (tipoCuenta: string) => requests.get<SaldosReportes[]>(`/CCTCuentas/ReportBalance/${tipoCuenta}`)
}

const Inscriptions = {
    create : (Inscriptions: InscriptionFormValues) => requests.post<string>('/Inscriptions', Inscriptions),
    delete: (Inscriptions: DeleteInscriptionFormValues) => requests.post<string>('/Inscriptions/UnEnrollment',Inscriptions)
}

const Account = {
    current: () => requests.get<User>('/account'),
    login: (user: UserFormValues) => requests.post<User>('/account/login', user),
    register: (user: UserFormValues) => requests.post<User>('/account/register', user),
    recuperarUsuario: (dpi: RecuperarUsuarioFormValues)  => requests.post<RecuperarUsuarioRespuesta>('/AccountsManager/forgot-user', dpi),
    // * administrar usuarios
    cambiarCorreoyContraseña: (credenciales: CambiarCorreoyContraseñaFormValues) => requests.put<CambiarCorreoyContraseña>('/AccountsManager/update-user', credenciales),
    actualizarContraseña: (credenciales: any) => requests.put<any>('/AccountsManager/ChangePassword', credenciales),
    listaUsuarios: (pagina: any, delegacion: any) => requests.get<UserList>(`/Account/List/${pagina}/${delegacion}`),
    busquedaUsuario: (criterio: UserListBusquedaFormValues) => requests.post<UserListBusqueda>('/Account/Search', criterio),
    deleteUser: (id: string) => requests.del<any>(`/Account?AppUserId=${id}`),
    cursosXusuario: (id: string) => requests.get<CoursesList>(`/Courses/MyCourses?Student=${id}`),
    cuentaXcurso: (id: string) => requests.get<cuentasCursosList[]>(`/Account/me/${id}`)
}

const Profiles = {
    get: (username: string) => requests.get<Profile>(`/profiles/${username}`),
    uploadFoto: (file: Blob) => {
        let formData = new FormData();
        formData.append('File', file);
        return axios.post<Foto>('fotos', formData, {
            headers: {'Content-type': 'multipart/form-data'}
        })
    },
    setMainFoto: (id: string) => requests.post(`/fotos/${id}/setMain`, {}),
    deleteFoto: (id: string) => requests.del(`/fotos/${id}`)
}

const Cargas = {
    uploadFile: (selectedFile: File) => {
        let formData = new FormData();
        formData.append('files', selectedFile);
        return axios.post<Information[]>('/Bank/Load', formData, {
            headers: {'Content-type': 'multipart/form-data'}
        })
    },
    uploadFileInscripcion: (selectedFile: File) => {
        let formData = new FormData();
        formData.append('files', selectedFile);
        return axios.post<Information[]>('/CATConvenios/ImportData', formData, {
            headers: {'Content-type': 'multipart/form-data'}
        })
    },
}   

const Convenios = {
    create: (convenioId: createCATConvenios) => requests.post<string>('/CATConvenios', convenioId),
    buscarEntidades: (idEntidad:string)=>requests.get<BuscarEntidad>(`/SGTEntidades/${idEntidad}`),
}

const Cuotas = {
    details: (catcursoid: string, catedicionid: string) => requests.get<CuotasMod[]>(`/CCTPlanCuota/${catcursoid}/${catedicionid}`),
    ListCuotasDetail: (catcursoid: string, catedicionid: string) => requests.get<CCTPlanCuotaDetails[]>(`/CCTPlanCuota/${catcursoid}/${catedicionid}`),
    create : (CuotasMod: CuotasModFormValues) => requests.post<string>('/CCTPlanCuota', CuotasMod),
    listCuotas :  () => requests.get<CuotasMod[]>('/CCTPlanCuota'),
    listDetailedCuotas:()=>requests.get<CCTPlanCuotaDetails[]>('/CCTPlanCuota/DetailedCCTPlanCuota'),

    report: (CCTMovimientoConsulta: CCTMovimientoConsultaFormValues) => requests.post<CCTMovimientoReportes[]>('/CCTMovimientos/ReportByDateRange', CCTMovimientoConsulta),
    update: (id: number, estatus: string) => requests.put<string>(`/CCTMovimientos/updateStatus/id/${id}/status/${estatus}`, CCTOperacion),
    getCuota: (catEdicionId: number) => requests.get<MontoCuota[]>(`/CCTPlanCuota/Edition/${catEdicionId}`)
}

const CATCursos = {
    create : (Id: string, CodigoCurso: string, Nombre: string, Objetivos: string, Modalidad: string, Contacto: string, iFrame:string, image: Blob, banner: Blob, Competencias: string, Perfil: string, Metodologia: string, Contenido: string, Nivel: string, Certificacion: string, Phone: string) => {
        let formData = new FormData();
        formData.append('Id', "0");
        formData.append('CodigoCurso', CodigoCurso);
        formData.append('Nombre', Nombre);
        formData.append('Objetivos', Objetivos);
        formData.append('Modalidad', Modalidad);
        formData.append('Contacto', Contacto);
        formData.append('image', image);
        formData.append('banner', banner);
        formData.append('iFrame', iFrame);
        formData.append('Competencias', Competencias);
        formData.append('Perfil', Perfil);
        formData.append('Metodologia', Metodologia);
        formData.append('Contenido', Contenido);
        formData.append('Nivel', Nivel);
        formData.append('Certificacion', Certificacion ?? '1');
        formData.append('Phone', Phone);
        return axios.post<createCATCursosFormValues>('/Courses', formData, {
            headers: {'Content-type': 'multipart/form-data'}
        })
    },
    update : (Id: any, CodigoCurso: string, Nombre: string, Objetivos: string, Modalidad: string, Contacto: string, iFrame:string, image: Blob, banner: Blob, Competencias: string, Perfil: string, Metodologia: string, Contenido: string, Nivel: string, Certificacion: string, Phone: string) => {
        let formData = new FormData();
        formData.append('Id', Id);
        formData.append('CodigoCurso', CodigoCurso);
        formData.append('Nombre', Nombre);
        formData.append('Objetivos', Objetivos);
        formData.append('Modalidad', Modalidad);
        formData.append('Contacto', Contacto);
        formData.append('image', image);
        formData.append('banner', banner);
        formData.append('Competencias', Competencias);
        formData.append('Perfil', Perfil);
        formData.append('Metodologia', Metodologia);
        formData.append('Contenido', Contenido);
        formData.append('iFrame', iFrame);
        formData.append('Nivel', Nivel);
        formData.append('Certificacion', Certificacion);
        formData.append('Phone', Phone)
        return axios.put<createCATCursosFormValues>('/Courses', formData, {
            headers: {'Content-type': 'multipart/form-data'}
        })
    },
    getCourses: () => requests.get<createCATCursos[]>('/Courses'),
    list: () => requests.get<Pagination<getCATCursos>>('/Courses/1/150'),
    listP: (pageNumber:number, size:number) => requests.get<Pagination<getCATCursos>>(`/Courses/${pageNumber}/${size}`),

    getCursosByDir: (direccion:string, delegacion:string) => requests.get<getCATCursos[]>(`Courses/GetByCategory/${direccion}/${delegacion}`),
    getArancel: (edicion:string) => requests.get<[]>(`CCTPlanCuota/Edition/${edicion}`),
    detail: (id:string) => requests.get<getCATCursoDetail[]>(`Courses/${id}`) ,
    getCoursesL: () => requests.get<CATCursosL[]>('/Courses/obtenercursos'),
    getNotas: () => requests.get<getCATNotas[]>('/Courses/Notas'),
    createDiploma: (edicion: number) => requests.get<string>(`/Docs/Edicion/${edicion}`),
    getGrades: (cui: string) => requests.get<Degree[]>(`/docs/DegreesByUser/${cui}`),
    getSearch: (keyword: string) => requests.get<lstCourses[]>(`/Courses/GetList?Search=${keyword}`)
}

const getCATEdiciones = {
    getEditionsByCourse :(codigocurso:number)=>requests.get<CATEdiciones[]>(`/CATEdiciones/CodigoCurso/${codigocurso}`),
    getEditionsByCourse2 :(id:number)=>requests.get<CATEdicionesL[]>(`/CATEdiciones/CodigoCurso/${id}`),
    create: (edicion: CATEdiciones) => requests.post<void>(`/CATEdicion`, edicion),
    getEdicionesInfo:() => requests.get<getEdiciones[]>('/CATEdiciones'),
    getEdicionesConv:() => requests.get<getEdiciones[]>('/CATEdicion'),
    update: (edicion: CATEdiciones, id: any) => requests.put<void>(`/CATEdicion/${id}`, edicion)
}

const CATModulos = {
    create: (modulo: createCATModulos)  => requests.post<void>(`/CATModulos`, modulo),
}

const Roles = {
    create: (nombre: string)  => requests.post<string>(`/Roles/${nombre}`, nombre),
    createPermisosToRoles: (permisos: createPermisostoRol) => requests.post<void>(`/RPTPermissions`, permisos),
    listPermisos: () => requests.get<listPermisosFormValues[]>(`/RPTPermissions/Perms`),
    asignarRolaUsuario: (idrol: string, idUser: string, entidad: string) => requests.post<string>(`/Roles/ToAssingRole/${idUser}/${idrol}/${entidad}`, idrol),
    listRoles: () => requests.get<listRolesFormValues[]>(`/Roles`),
    edit: (id:any, nombre: string) => requests.put<void>(`/Roles/RolId${id}/RolName/${nombre}`, nombre),
    editpermisos: (id:any) => requests.get<listPermisosByRoleFormValues[]>(`/RPTPermissions/PermissionsByRole/id${id}`),
    
}

const Exoneracion = {    
    create : (ExoneracionesMod: ExoneracionesModFormValues) => requests.post<string>('/CCTExoneracion', ExoneracionesMod),
    getExoneracion:()=>requests.get<ExoneracionesList[]>('/CCTExoneracion/DetailedExoneration'),
    getIdcontrol :(idcontrol:number)=>requests.get<ExoneracionesMod[]>(`/CCTExoneracion/${idcontrol}`),
    transxPorCuenta: (curso: string) => requests.get<getTranx[]>(`/CCTExoneracion/TransXCurso/${curso}`),
    getExoDetail:(id:number)=>requests.get<ExoneracionesDetail[]>(`/CCTExoneracion/DetailedExoneration/${id}`),
    updateExoneraciones: (ExoneracionesMod: ExoneracionesModFormValues) => requests.put<void>(`/CCTExoneracion/${ExoneracionesMod.idcontrol}`, ExoneracionesMod),
    applyDiscount: (ExoneracionesMod: ExoneracionesModFormValues) => requests.put<void>(`/CCTExoneracion/apply/${ExoneracionesMod.idcontrol}`, ExoneracionesMod)
    }

const Notificar = {
    getNotificar:()=>requests.get<Notificacion[]>('/UVNotificaciones'),
}

const Recibo = {
    createRecibo : (RecibosMod: RecibosFormValues) => requests.post<string>('/CCTRecibos', RecibosMod),
    PdfRecibo: (id_Recibo: number) => requests.get<RecibosFormValues[]>(`/CCTRecibos/${id_Recibo}`),
    createReciboAgencia: (ReciboAgenciaMod: RecibosAgenciaFormValues) => requests.post<string>('/CCTVouchers', ReciboAgenciaMod),
    PdfReciboAgencia: (id: number) => requests.get<RecibosAgenciaFormValues[]>(`/CCTVouchers/id/${id}`)


}

const Passw = {
    passReload : (PassMod: PassModFormValues) => requests.post<string>('/AccountsManager/request-reset-password', PassMod),
    passReset : (ResetPassMod: ResetPassModFormValues) => requests.post<string>('/AccountsManager/reset-password', ResetPassMod),
}

const Reportes = {
    inscripciones : () => requests.get<ReportDTO[]>('/Reports/Reporte-Inscritos'),
    inscripcion : (value: any, year: number, page: number, size: number) => requests.get<Pagination<ReporteInscripcionFormValues>>(`/Reports/Reporte-Inscritos/Busqueda/${page}/${size}/${value}/${year}`),
    banrural: (value: any, page: number, size: number) => requests.get<Pagination<ReporteBanruralFormValues>>(`/Reports/Reporte-Movimientos/Busqueda/${page}/${size}/${value}`),
    banruralExport: (value: any) => requests.get(`/Reports/Reporte-Movimientos/Export/${value}`),
    export: (value: any, year: number) => requests.get(`/Reports/Reporte-Inscritos/Export/${year}/${value}`)
}

const Docentes = {
    list : () => requests.get<ListDocentes>(`/CATCatedraticos`),
    search : (CUI:string) => requests.get<ListDocentes>(`/CATCatedraticos?CUI=${CUI}`),
    paginacion : (page:number) => requests.get<ListDocentes>(`/CATCatedraticos?page=${page}`),
}

const Delegaciones = {
    list : () => requests.get<Delegacion[]>('/CATDelegaciones'),
}

const agent = {
    Activities,
    SGPersonas,
    SGTDepartamentos,
    SGTEntidades,
    SGTMunicipios,
    SGTComunidades,
    CCTiposDeCuentas,
    Account,
    CCTiposDeDocumentos,
    CCTiposDeTransacciones,
    CCTTiposTransXTipoCtas,
    CCTCuentas,
    CCTMovimientos,
    CCTOperaciones,
    Inscriptions,
    Profiles,
    Cargas,
    SaldosReporte,
    Cuotas,
    CATCursos,
    getCATEdiciones,
    CATModulos,
    Exoneracion,
    Notificar,
    Recibo,
    Convenios,
    Passw,
    Roles,
    Reportes,
    Docentes,
    Delegaciones
}

export default agent;
// function f(arg0: string, f: any) {
//     throw new Error('Function not implemented.');
// }